<template>
    <el-drawer :visible="visible" :direction="direction" :title="title" @close="closeDrawer" :size="size">
        <slot></slot>
    </el-drawer>
</template>

<script>
export default {
    name: 'GlobalDrawer',
    data() {
        return {
            visible: false,
            title: '',
            size: "30%",
            direction: "rtl"
        };
    },
    methods: {
        closeDrawer() {
            if (this.beforeClose) {
                this.beforeClose();
            }
            this.visible = false;
        }
    }
};
</script>

<style lang="less" scoped></style>